import { render, staticRenderFns } from "./FaqInfoView.vue?vue&type=template&id=d622ee84&"
import script from "./FaqInfoView.vue?vue&type=script&lang=js&"
export * from "./FaqInfoView.vue?vue&type=script&lang=js&"
import style0 from "./FaqInfoView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports